import React, { createElement, Fragment } from "react";
import { Helmet } from "react-helmet";
import { Success } from "ducks/GetAPreliminaryProposal/success";

export default function SuccessPage(props) {
  return (
    <Fragment>
      <Helmet>
        <title>{"Success - Savant Power"}</title>
      </Helmet>
      {createElement(Success, props)}
    </Fragment>
  );
}
